import logo from '@modules/logo';
import { memo } from 'react';

type Props = {
    /** Preferred width in viewport-width units, clamped so it stays legible and never dominates. */
    baseWidthVw?: number;
};

const DEFAULT_BASE_WIDTH = 20;
const MIN_WIDTH = '140px';
const MAX_WIDTH = '220px';

const LogoStack = ({ baseWidthVw = DEFAULT_BASE_WIDTH }: Props) => {
    return (
        <img
            key={logo}
            src={logo}
            alt="Logo"
            loading="lazy"
            style={{
                margin: '0 auto',
                // A bare `vw` width renders this at ~75px on a phone and ~500px on a 27" monitor.
                width: `clamp(${MIN_WIDTH}, ${baseWidthVw}vw, ${MAX_WIDTH})`,
                height: 'auto',
            }}
        />
    );
};

export default memo(LogoStack);
